import { Avatar, Box, Card, CardContent, CardHeader, Chip, Divider, IconButton, Modal, Typography } from "@mui/material";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { ISetup } from "../../../shared/services/api/financial/FinancialService";
import { globalColorTextSetup, globalMaskDocument, globalTranslatePayment, globalTranslateStatusTaxSetup } from "../../../shared/utils";

interface IModalDetailSetupProps {
	rowSetup: ISetup;
	isOpenModal: boolean;
	isCloseModal?: () => void;
	widthModfy?: string;
	heightModfy?: string;
	onclickConfirm?: () => void;
	onCloseModal?: (event?: {}, reason?: "backdropClick" | "escapeKeyDown") => void;
	overrideWidthValue?: string;
	overrideHeightValue?: string;
}

const style = {
	position: "relative",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "50%",
	height: "auto",
	maxWidth: "75%",
	maxHeight: "85%",
	bgcolor: "background.paper",
	border: "1px solid #605e5e",
	boxShadow: 24,
	borderRadius: "12px",
	display: "flex",
	flexDirection: "column",
	backgroundColor: "#FFF",
	padding: 3,
};

export const ModalDetailSetup: React.FC<IModalDetailSetupProps> = ({ rowSetup, isOpenModal, onCloseModal, overrideWidthValue, overrideHeightValue }) => {
	return (
		<Modal open={isOpenModal} onClose={onCloseModal}>
			<Box
				sx={{
					...style,
					width: overrideWidthValue || style.width,
					height: overrideHeightValue || style.height,
				}}
			>
				<Box display="flex" justifyContent="center">
					<Typography variant="h5" py={2} textAlign="center" color="primary">
						Detalhamento de taxa de setup
					</Typography>
				</Box>

				<Card variant="outlined" sx={{ width: "100%" }}>
					<CardContent>
						<Typography variant="subtitle1" fontWeight={600} gutterBottom>
							Imobiliária
						</Typography>
						<Typography variant="body2">{rowSetup.client_name}</Typography>
						<Typography variant="body2" color="text.secondary">
							{globalMaskDocument(rowSetup.client_document ?? "0")}
						</Typography>

						<Divider sx={{ my: 2 }} />

						<Typography variant="subtitle1" fontWeight={600} gutterBottom>
							Cliente
						</Typography>
						<CardHeader
							sx={{ px: 0 }}
							avatar={<Avatar sx={{ bgcolor: "primary.main" }}>{rowSetup.tenant_name.trim().charAt(0)}</Avatar>}
							title={<Typography fontWeight={500}>{rowSetup.tenant_name}</Typography>}
							subheader={globalMaskDocument(rowSetup.tenant_document ?? "")}
						/>

						<Divider sx={{ my: 2 }} />

						<Typography variant="subtitle1" fontWeight={600} gutterBottom>
							Cobrança
						</Typography>
						<Box display="flex" flexWrap="wrap" gap={4} mb={2}>
							<Box>
								<Typography variant="body2" fontWeight={500}>
									Data de criação
								</Typography>
								<Typography variant="body2">{format(new Date(rowSetup.created_at), "dd/MM/yyyy", { locale: ptBR })}</Typography>
							</Box>

							{rowSetup.status === "canceled" && (
								<>
									<Box>
										<Typography variant="body2" fontWeight={500} color="error">
											Data Cancelamento
										</Typography>
										{rowSetup.canceled_at && (
											<Typography variant="body2">{format(new Date(rowSetup.canceled_at), "dd/MM/yyyy", { locale: ptBR })}</Typography>
										)}
									</Box>
									<Box>
										<Typography variant="body2" fontWeight={500} color="error">
											Motivo Cancelamento
										</Typography>
										<Typography variant="body2">{rowSetup.reason}</Typography>
									</Box>
									<Box>
										<Typography variant="body2" fontWeight={500} color="error">
											Descrição
										</Typography>
										<Typography variant="body2">{rowSetup.note}</Typography>
									</Box>
								</>
							)}

							{rowSetup.status === "paid" && (
								<>
									<Box>
										<Typography variant="body2" fontWeight={500}>
											Data Pagamento
										</Typography>
										<Typography variant="body2">{format(new Date(rowSetup.payment_date ?? ""), "dd/MM/yyyy", { locale: ptBR })}</Typography>
									</Box>
									<Box>
										<Typography variant="body2" fontWeight={500}>
											Valor Pago
										</Typography>
										<Typography variant="body2">
											{parseFloat(rowSetup.credit_amount ?? "0").toLocaleString("pt-br", {
												style: "currency",
												currency: "BRL",
											})}
										</Typography>
									</Box>
									<Box>
										<Typography variant="body2" fontWeight={500}>
											Taxa Administrativa
										</Typography>
										<Typography variant="body2">
											{parseFloat(rowSetup.administrative_amount ?? "0").toLocaleString("pt-br", {
												style: "currency",
												currency: "BRL",
											})}
										</Typography>
									</Box>
								</>
							)}
						</Box>

						<Divider sx={{ my: 2 }} />

						<Typography variant="subtitle1" fontWeight={600} gutterBottom>
							Pagamento
						</Typography>
						<Box display="flex" flexWrap="wrap" gap={4} alignItems="center">
							<Box>
								<Typography variant="body2" fontWeight={500}>
									Statusss
								</Typography>
								<Chip
									label={globalTranslateStatusTaxSetup(rowSetup.status)}
									sx={{
										fontSize: 14,
										mt: 0.5,
										color: globalColorTextSetup(rowSetup.status),
										borderColor: globalColorTextSetup(rowSetup.status),
									}}
									variant="outlined"
								/>
							</Box>
							<Box>
								<Typography variant="body2" fontWeight={500}>
									Forma de pagamento
								</Typography>
								<Typography variant="body2">{globalTranslatePayment(rowSetup.payment_method ?? "")}</Typography>
							</Box>
							<Box>
								<Typography variant="body2" fontWeight={500}>
									Vencimento
								</Typography>
								<Typography variant="body2">{format(new Date(rowSetup.dueDate ?? ""), "dd/MM/yyyy", { locale: ptBR })}</Typography>
							</Box>
							<Box minWidth={200}>
								<Typography variant="body2" fontWeight={500}>
									Valor
								</Typography>
								<Chip
									label={parseFloat(rowSetup.raw_amount ?? "0").toLocaleString("pt-br", {
										style: "currency",
										currency: "BRL",
									})}
									color="primary"
									sx={{ fontSize: 16, mt: 0.5 }}
								/>
							</Box>
						</Box>
					</CardContent>
				</Card>
			</Box>
		</Modal>
	);
};
